import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getAuthenticatedHeaders } from '../fetch/fetchHeaders';
import { logRequestTiming } from '../fetch/insightsHelper';

export const fetchPermissions = createAsyncThunk(
    'users/fetchByIdStatus',
    async (thunkAPI) => {
        const response = await getAuthenticatedHeaders().then((headers) => {
            return fetch('configuration/permissions', { headers })
                .then(response => response.json())
        })
        return response;
    }
)

export const permissionsSlice = createSlice({
    name: 'permissions',
    initialState: {
        isLoaded: false,
        accountNumber: '',
        businessGroups: [],
        litStates: [],
        isRecognized: false,
        language: '',
        canDownload: false,
        hasVesselHistory: false,
        isMercNetUser: false,
        requiresMercNetLinkIn: false,
        hasTechAssist: false,
        hasServiceLog: false,
        isInMercNet: false,
        hasRatesCalculator: false,
        deployDate: '',
        deployVersion: ''
    },
    reducers: {
        startReload: (state) => {
            state.isLoaded = false
        }
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        const startTime = performance.now(); // Start timing
        builder.addCase(fetchPermissions.fulfilled, (state, action) => {
            const endTime = performance.now(); // End timing
            logRequestTiming('configuration/permissions', Math.round(endTime - startTime));

            state.isLoaded = true;
            state.accountNumber = action.payload.accountNumber;
            state.businessGroups = action.payload.businessGroups;
            state.litStates = action.payload.litStates;
            state.isRecognized = action.payload.isRecognized;
            state.language = action.payload.language;
            state.canDownload = action.payload.canDownload;
            state.hasVesselHistory = action.payload.hasVesselHistory;
            state.isMercNetUser = action.payload.mercNet;
            state.requiresMercNetLinkIn = action.payload.requiresMercNetLinkIn;
            state.hasTechAssist = action.payload.hasTechAssist;
            state.hasServiceLog = action.payload.hasServiceLog;
            state.isInMercNet = action.payload.isInMercNet;
            state.hasRatesCalculator = action.payload.hasRatesCalculator;
            state.deployDate = action.payload.deployDate;
            state.deployVersion = action.payload.deployVersion;
        })
    },
})

// Action creators are generated for each case reducer function
export const { startReload } = permissionsSlice.actions

export default permissionsSlice.reducer